import { legacyMap, keyMap } from "./fieldRegistry";

// Translates an object's top-level keys from clean UI names to the legacy
// names calculation.js/estimation.js/pvUtils.js/sqliteApi.js expect.
// Unmapped keys (calc-tab-internal names, DataGridView* etc.) pass through.
export function toLegacy(data) {
  if (!data || typeof data !== "object") return data;

  const result = {};
  for (const [key, value] of Object.entries(data)) {
    result[legacyMap[key] || key] = value;
  }
  return result;
}

// Reverse of toLegacy - translates a legacy-keyed object (typically a
// calculation result) back to clean UI names before it's written onto
// form state.
export function fromLegacy(data) {
  if (!data || typeof data !== "object") return data;

  const result = {};
  for (const [key, value] of Object.entries(data)) {
    result[keyMap[key] || key] = value;
  }
  return result;
}

// Single-key helper for call sites that translate one field name at a
// time rather than a whole object (e.g. a setValue(key, value) loop).
export function toLegacyKey(key) {
  return legacyMap[key] || key;
}

export function fromLegacyKey(key) {
  return keyMap[key] || key;
}
